import { GAME_METADATA } from '@brick-rogue/game-content';
import { Link, NavLink } from 'react-router';

interface AppHeaderProps {
  readonly compact?: boolean;
}

export function AppHeader({ compact = false }: AppHeaderProps) {
  return (
    <header className="site-header" data-compact={compact}>
      <Link className="site-brand" to="/" aria-label="返回首页">
        <i aria-hidden="true">◆</i>
        <span>
          <small>VOIDLINE OPERATIONS</small>
          <strong>{GAME_METADATA.title}</strong>
        </span>
      </Link>
      <nav aria-label="主导航">
        <NavLink to="/levels">关卡</NavLink>
        <NavLink to="/challenges">挑战</NavLink>
        <NavLink to="/objectives">目标</NavLink>
        <NavLink to="/seasons">赛季</NavLink>
        <NavLink to="/codex">图鉴</NavLink>
        <NavLink to="/settings">设置</NavLink>
        <Link className="nav-play" to="/levels">
          进入战斗
        </Link>
      </nav>
    </header>
  );
}
